import type { UniqueIdentifier } from '@dnd-kit/core';

const STAGE_DROPPABLE_PREFIX = 'leads-funnel-stage:';
const LEAD_SORTABLE_PREFIX = 'leads-funnel-lead:';

export const buildStageDroppableId = (stageId: number): string =>
  `${STAGE_DROPPABLE_PREFIX}${stageId}`;

export const buildLeadSortableId = (leadId: number): string =>
  `${LEAD_SORTABLE_PREFIX}${leadId}`;

export const parseStageDroppableId = (id: UniqueIdentifier): number | null => {
  if (typeof id !== 'string' || !id.startsWith(STAGE_DROPPABLE_PREFIX)) {
    return null;
  }

  const value = Number(id.slice(STAGE_DROPPABLE_PREFIX.length));

  return Number.isNaN(value) ? null : value;
};

export const parseLeadSortableId = (id: UniqueIdentifier): number | null => {
  if (typeof id !== 'string' || !id.startsWith(LEAD_SORTABLE_PREFIX)) {
    return null;
  }

  const value = Number(id.slice(LEAD_SORTABLE_PREFIX.length));

  return Number.isNaN(value) ? null : value;
};
